var chunkToChildrenMap = {"8074":["8074","3831"],"1591":["8074","3831"],"8783":["8074","3831"],"6536":["8074"],"9626":["8074","3831"],"3606":["8074","3831"],"4585":["8074","3831"],"4118":["8074","3831"],"9102":["8074","3831"]};
__webpack_require__.f.prefetch = (chunkId, promises) => {
  Promise.all(promises).then(() => {
    var chunks = chunkToChildrenMap[chunkId];
    Array.isArray(chunks) && chunks.map(__webpack_require__.E);
  });
};